import { useTranslation } from 'react-i18next';
import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { useDispatch } from 'react-redux';

import { AgentLookupResponse } from '@breathelife/types';

import { notificationSlice } from '../../ReduxStore/Notification/NotificationSlice';
import { getAdvisorByCode } from '../../Services/AgentLookupService';

export function useLookupAdvisorMutation(
  options?: UseMutationOptions<AgentLookupResponse, unknown, string>,
): UseMutationResult<AgentLookupResponse, unknown, string> {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return useMutation<AgentLookupResponse, unknown, string>((agentCode: string) => getAdvisorByCode(agentCode), {
    ...options,
    onSuccess: async (data, variables, context) => {
      if (data.status === 'notFound') {
        dispatch(notificationSlice.actions.setWarning({ message: t('notifications.agentNotFound') }));
      }

      if (options?.onSuccess) {
        await options.onSuccess(data, variables, context);
      }
    },
    onError: async (error, variables, context) => {
      dispatch(notificationSlice.actions.setError({ message: t('notifications.agentLookupError') }));

      if (options?.onError) {
        await options.onError(error, variables, context);
      }
    },
  });
}
